// Generación del archivo .ics para "Agregar a mi calendario".
//
// Se arma a mano porque el formato es simple y traer una librería para esto
// sería desproporcionado. Las fechas van en UTC (sufijo Z), que es lo que
// entienden todos los calendarios sin tener que declarar la zona.

const BARRA = String.fromCharCode(92); // '\'

function aUtc(fecha) {
  return new Date(fecha).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

/**
 * En un .ics hay caracteres que se escapan con barra invertida. Si no, un
 * servicio con una coma en el nombre parte el campo en dos y el archivo deja
 * de abrirse.
 */
function escapar(texto) {
  return String(texto ?? '')
    .split(BARRA).join(BARRA + BARRA)
    .split(';').join(BARRA + ';')
    .split(',').join(BARRA + ',')
    .split('\n').join(BARRA + 'n');
}

/** Las líneas del .ics no pueden pasar de 75 caracteres: se pliegan. */
function plegar(linea) {
  if (linea.length <= 75) return linea;

  const partes = [linea.slice(0, 75)];
  let resto = linea.slice(75);

  while (resto.length > 74) {
    partes.push(` ${resto.slice(0, 74)}`);
    resto = resto.slice(74);
  }
  if (resto) partes.push(` ${resto}`);

  return partes.join('\r\n');
}

export function armarIcs({ turno, servicio, profesional, negocio }) {
  const lineas = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//HolaTurnos//Reservas//ES',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${turno.id}@holaturnos.com`,
    `DTSTAMP:${aUtc(new Date())}`,
    `DTSTART:${aUtc(turno.inicio)}`,
    `DTEND:${aUtc(turno.fin)}`,
    `SUMMARY:${escapar(`${servicio} en ${negocio}`)}`,
    `DESCRIPTION:${escapar(`Turno con ${profesional}. Si no podés venir, avisá con tiempo.`)}`,
    `LOCATION:${escapar(negocio)}`,
    'STATUS:CONFIRMED',
    // Un aviso propio del calendario, una hora antes. El recordatorio por
    // WhatsApp lo manda el negocio aparte.
    'BEGIN:VALARM',
    'TRIGGER:-PT1H',
    'ACTION:DISPLAY',
    `DESCRIPTION:${escapar(`Turno en ${negocio} en una hora`)}`,
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ];

  return lineas.map(plegar).join('\r\n');
}

/** Dispara la descarga del .ics en el navegador. */
export function descargarIcs(datos, nombreArchivo = 'turno.ics') {
  const contenido = armarIcs(datos);
  const blob = new Blob([contenido], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombreArchivo;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);

  // Sin esto el blob queda en memoria hasta que se cierre la pestaña.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
